import { render, staticRenderFns } from "./src/pages/movie_reviews.html?vue&type=template&id=6a7cd78a&scoped=true&"
import script from "./src/pages/movie_reviews.js?vue&type=script&lang=js&"
export * from "./src/pages/movie_reviews.js?vue&type=script&lang=js&"
import style0 from "./src/pages/movie_reviews.scss?vue&type=style&index=0&id=6a7cd78a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7cd78a",
  null
  
)

export default component.exports